<script>
  import { onMount } from "svelte";

  let blog_urls = [];

  onMount(async () => {
    let res = await fetch("../urls.txt");
    blog_urls = await res.json();
  });
</script>

<div class="flex flex-col items-center justify-center dark:text-white">
  {#each blog_urls as url}
  <div class="w-1/2 rounded p-4 mb-2 border dark:hover:bg-gray-600 hover:bg-gray-100 dark:border-gray-600 border-gray-100 transition-colors">
    <a
      href={url.url}>{url.filename}</a
    >
  </div>
  {/each}
</div>
